
// const hoge = "hogehoge"
// console.log(hoge)

// console.log("最初");

// // お約束を取り付けたい処理にPromise
// new Promise((resolve) => {
//   //1秒後に実行する処理
//   setTimeout(() => {
//     console.log("2番目(1秒後に実行)");
//     //無事処理が終わったことを伝える
//     resolve();
//   }, 1000);
// }).then(() => {
//   // 処理が無事終わったことを受けとって実行される処理
//   console.log("3番目");
// });

// // 約一秒後、受け取った値を2倍で返す非同期関数
// const promiseFunc = value => {
//   return new Promise((resolve, reject) => {
//     setTimeout(() => {
//       resolve(value * 2);
//     }, 1000);
//   });
// };

// // 非同期関数
// async function asyncFunc() {
//   // await 式によって順番に処理される
//   const a = await promiseFunc(1);
//   const b = await promiseFunc(2);
//   const c = await promiseFunc(33);

//   return a + b + c;
// }

// asyncFunc().then(value => {
//   console.log(value); // => 12
// });

// import Vue from 'vue'
// import Vue from 'vue/dist/vue.esm.js';
// import axios from 'axios'
// // import Inview from 'in-view'
import objectFitImages from 'object-fit-images';
// require('intersection-observer');

//object fit
objectFitImages('.cover img', { watchMQ: true });

import { loadDefaultJapaneseParser } from "budoux";
const parser = loadDefaultJapaneseParser();
const elements = document.getElementsByClassName('budou-this');
  for(let i = 0; i < elements.length; i++) {
    parser.applyElement(elements[i]);
}

// lightbox
import { Luminous, LuminousGallery } from 'luminous-lightbox';
// import 'luminous-lightbox/dist/luminous-basic.min.css';
//luminous クラスを指定した a 要素を取得
// const luminousElem = document.querySelector('.luminous');
// const luminousElems = document.querySelectorAll('.luminous');
//querySelectorAll() で全ての luminous3 クラスを指定した a 要素を取得
const luminousGalleryElems = document.querySelectorAll('.luminous');
// または getElementsByClassName() を使ってもほぼ同じ（※）
//const luminousGalleryElems = document.getElementsByClassName('luminous3');


//上記で要素が取得できていれば Luminous を初期化
// if( luminousElem !== null ) {
//   new Luminous(luminousElem);
// }
//取得した要素の数が 0 より大きければ
// if( luminousElems.length > 0 ) {
//   luminousElems.forEach( (elem) => {
//     new Luminous(elem);
//   });
// }
//取得した要素の数が 0 より大きければ
if( luminousGalleryElems.length > 0 ) {
  // LuminousGallery で初期化
  new LuminousGallery(luminousGalleryElems);
}


// loading 画面

if (document.getElementById('js-loader')) {
  const loader = document.getElementById('js-loader');
  const keyName = 'visited';
  const keyValue = true;

  if (!sessionStorage.getItem(keyName)) {
    //sessionStorageにキーと値を追加
    sessionStorage.setItem(keyName, keyValue);

    //ここに初回アクセス時の処理
    // console.log("初めての訪問です");
    loader.classList.add("active");

  } else {
    //ここに通常アクセス時の処理
    // console.log("訪問済みです");

  }
  window.addEventListener('load', () => {
    const ms = 400;
    loader.style.transition = 'opacity ' + ms + 'ms';

    const loaderOpacity = function () {
      loader.style.opacity = 0;
    }
    const loaderDisplay = function () {
      loader.style.display = 'none';
    }
    // setTimeout(loaderOpacity, 1);
    // setTimeout(loaderDisplay, ms);
    // デモ用
    setTimeout(loaderOpacity, 3000);
    setTimeout(loaderDisplay, 3500 + ms);
  });
}

// sticky header
function scrollFunction() {
  var this_y = window.pageYOffset;
  const nav_el = document.querySelector('.spmenu_btn')
  // console.log(this_y)
  if (this_y > 130) {
    document.getElementById("header").classList.add("active");
    nav_el.classList.add("active");
    setTimeout(() => {
      document.getElementById("header").classList.add("in-view");
      nav_el.classList.add("in-view");
    }, 1000)
  } else {
    document.getElementById("header").classList.remove("active", "in-view");
    nav_el.classList.remove("active", "in-view");
  }
}
window.onload = function () {
  scrollFunction();
}
window.onscroll = function () {
  scrollFunction();
}

// Nav
if (document.getElementsByClassName('globalNav')[0]) {
  const wrap = document.querySelector('.menu__btnwrap')
  const nav_el = document.querySelector('.spmenu_btn')
  const nav_state_class = 'globalNav_state'
  const nav_target_class = '.globalNav'
  const nav_close_class = 'spmenu_btnClose'
  const nav_wrap = document.querySelector('.menu')

  wrap.addEventListener('click', () => {
    if (document.querySelector('.' + nav_state_class) === null) {
      document.querySelector(nav_target_class).classList.add(nav_state_class)
      nav_el.classList.add(nav_close_class)
    } else {
      document.querySelector(nav_target_class).classList.remove(nav_state_class)
      nav_el.classList.remove(nav_close_class)
    }
  }, false)

  nav_wrap.addEventListener('click', () => {
    document.querySelector(nav_target_class).classList.remove(nav_state_class)
    nav_el.classList.remove(nav_close_class)
  }, false)
}

// accordion
var trigger = document.querySelectorAll('.accordion__title');
for (var i = 0; i < trigger.length; i++) {
  trigger[i].addEventListener('click', function () {
    var body = this.nextElementSibling;
    if (this.classList.contains('is-active')) {
      this.classList.remove('is-active');
      body.classList.remove('is-open');
    } else {
      this.classList.add('is-active');
      body.classList.add('is-open');
    }
  });
}

// 外部リンク別窓
var external_link__add_blank = function () {
  var a_tags = document.querySelectorAll('a:not([target="_blank"])'),
    res = [];
  if (!a_tags.length) return; // a_tagsがマッチなし = end
  for (var i = 0; i < a_tags.length; i++) {
    if (a_tags[i].href.indexOf(window.location.host) !== -1) continue;
    if (a_tags[i].classList.contains('none')) continue;
    if (a_tags[i].classList.contains('sbi_load_btn')) continue;
    // if (a_tags[i].classList.contains('none')) continue;
    // console.log(a_tags[i].href)
    if (a_tags[i].href.indexOf('#') === 1) continue;
    a_tags[i].setAttribute('target', '_blank');
    res.push(a_tags[i])
  }
  return res;
}
// var a__add_blanks = external_link__add_blank(); console.log(a__add_blanks);
document.addEventListener('DOMContentLoaded', external_link__add_blank, false);

/*******************
  slide toggle関連
*******************/
// slideUp
const slideUp = (el, duration = 300) => {
  el.style.height = el.offsetHeight + "px";
  el.offsetHeight;
  el.style.transitionProperty = "height, margin, padding";
  el.style.transitionDuration = duration + "ms";
  el.style.transitionTimingFunction = "ease";
  el.style.overflow = "hidden";
  el.style.height = 0;
  el.style.paddingTop = 0;
  el.style.paddingBottom = 0;
  el.style.marginTop = 0;
  el.style.marginBottom = 0;
  setTimeout(() => {
    el.style.display = "none";
    el.style.removeProperty("height");
    el.style.removeProperty("padding-top");
    el.style.removeProperty("padding-bottom");
    el.style.removeProperty("margin-top");
    el.style.removeProperty("margin-bottom");
    el.style.removeProperty("overflow");
    el.style.removeProperty("transition-duration");
    el.style.removeProperty("transition-property");
    el.style.removeProperty("transition-timing-function");
  }, duration);
};

// slideDown
const slideDown = (el, duration = 300) => {
  el.style.removeProperty("display");
  let display = window.getComputedStyle(el).display;
  if (display === "none") {
    display = "block";
  }
  el.style.display = display;
  let height = el.offsetHeight;
  el.style.overflow = "hidden";
  el.style.height = 0;
  el.style.paddingTop = 0;
  el.style.paddingBottom = 0;
  el.style.marginTop = 0;
  el.style.marginBottom = 0;
  el.offsetHeight;
  el.style.transitionProperty = "height, margin, padding";
  el.style.transitionDuration = duration + "ms";
  el.style.transitionTimingFunction = "ease";
  el.style.height = height + "px";
  el.style.removeProperty("padding-top");
  el.style.removeProperty("padding-bottom");
  el.style.removeProperty("margin-top");
  el.style.removeProperty("margin-bottom");
  setTimeout(() => {
    el.style.removeProperty("height");
    el.style.removeProperty("overflow");
    el.style.removeProperty("transition-duration");
    el.style.removeProperty("transition-property");
    el.style.removeProperty("transition-timing-function");
  }, duration);
};

// slideToggle
const slideToggle = (el, duration = 300) => {
  if (window.getComputedStyle(el).display === "none") {
    return slideDown(el, duration);
  } else {
    return slideUp(el, duration);
  }
};

// スライドさせたい要素を取得
const el = document.querySelector('.toggle__content');
// ボタン
const slideToggleBtn = document.querySelector(".toggle__btn");
// slideToggle
if(slideToggleBtn){
  slideToggleBtn.addEventListener("click", () => {
    if(slideToggleBtn.classList.contains('close')){
      slideToggleBtn.classList.remove('close')
    }else{
      slideToggleBtn.classList.add('close')
    }
    slideToggle(el, 300);
  });
}



/*******************
  table スクロール
*******************/
import ScrollHint from 'scroll-hint';
new ScrollHint('.scroll-table', {
  scrollHintIconAppendClass: 'scroll-hint-icon-black', // white-icon will appear
  i18n: {
    scrollable: 'スクロールできます'
  }
});



/*******************
  お問い合わせ内容
*******************/
document.addEventListener('DOMContentLoaded', function() {
  // URLからクエリーパラメータを取得
  const urlParams = new URLSearchParams(window.location.search);
  const query = urlParams.get('query');

  // テキストエリアの要素を取得
  const textarea = document.getElementById('message');

  // MWWPFormから選択するべきオプションの値を取得する
  const selectedOptionValue = "採用について"; // 例: オプション2を選択する

// セレクトボックスの要素を取得
  const selectElement = document.getElementById("selectitem");

  // クエリーをテキストエリアにセット
  if (query && textarea) {
    textarea.value = query + 'について';
    // 選択されたオプションをセット
    selectElement.value = selectedOptionValue;
  }
});


/*******************
  modal ボタン
*******************/
// footerボタン用モーダル
// const modalBtns = document.querySelectorAll(".modal-toggle");
// modalBtns.forEach(function (btn) {
//   btn.onclick = function () {
//     var modal = btn.getAttribute('data-modal');
//     document.getElementById(modal).style.display = "block";
//   };
// });
// const closeBtns = document.querySelectorAll(".modal-close");
// closeBtns.forEach(function (btn) {
//   btn.onclick = function () {
//     var modal = btn.closest('.modal');
//     modal.style.display = "none";
//   };
// });

// window.onclick = function (event) {
//   if (event.target.className === "modal") {
//     event.target.style.display = "none";
//   }
// };

// /*******************
//   画像操作
// *******************/
// let screen = document.body.clientWidth;
// let container = document.querySelector('.container__min');
// // console.log(screen)
// // console.log(container)
// if(container){
//   const width = container.offsetWidth;
// }
// if(document.querySelectorAll('.overimg-right')){
//   let client_w = document.querySelectorAll('.overimg-right');
//   for (let node of client_w) {
//     node.style.marginRight = ((container - screen) / 2) + 'px';
//   }
//   // console.log(client_w)
//   // console.log(((container - screen) / 2) + 'px')
//   // client_w.style.marginRight = ((container - screen) / 2) + 'px';
//   // client_w.forEach{}
// }

// if(document.querySelectorAll('.overimg-left')){
//   let client_w = document.querySelectorAll('.overimg-left');
//   for (let node of client_w) {
//     node.style.marginLeft = ((container - screen) / 2) + 'px';
//   }
//   // console.log(((container - screen) / 2) + 'px')
//   // client_w.style.marginLeft = ((container - screen) / 2) + 'px';
// }

// /*******************
//   instagram
// *******************/
// if (document.getElementById('insta__saloncoco')) {
//   const postsInstance = new Vue({
//     el: "#insta__saloncoco",
//     data() {
//       return {
//         insta_url: 'https://graph.facebook.com/v12.0/',
//         instagram_business_id: '17841450062107536',
//         access_token: 'EAAJKs8lGM8cBAMcr0FSCjTFtKuLiZBr8qMUZAMt1ZB8v73DhPjUKGGp9OSF564DOyvTyhXNG4u7r80qTw0DFphFMY7GlyBxmewWndVZBPVOwofxXRHSCUCyx0KNZBWsF8amPyOcmxO2nF6dzZCFvOoKSKF6lEJYaUIEGED7nMyJeEv5gZCxvL6SioId4FrXGWYZD',
//         // target_user: 'cocoplus_1101',
//         target_user: 'salon.coco.0731',
//         // query = 'business_discovery.username(' + target_user + '){id,followers_count,media_count,ig_id,media{caption,media_url,media_type,like_count,comments_count,timestamp,id}}',
//         // query: 'name,media{caption,like_count,media_url,permalink,timestamp,username}',
//         queryFirst: 'business_discovery.username(',
//         queryLast: '){followers_count,media_count,media{caption,like_count,media_url,media_type,permalink,timestamp,username}}',
//         // query: 'business_discovery.username(kaori.y_studio){followers_count,media_count,media{caption,like_count,media_url,permalink,timestamp,username}}',
//         posts: [],
//       }
//     },
//     mounted() {
//       console.log(this.insta_url + this.instagram_business_id + '?fields=' + this.queryFirst + this.target_user + this.queryLast + '&access_token=' + this.access_token)
//       axios(this.insta_url + this.instagram_business_id + '?fields=' + this.queryFirst + this.target_user + this.queryLast + '&access_token=' + this.access_token)
//         .then((res) => {
//           this.posts = res.data.business_discovery.media.data
//           // 他人のアカウント
//           // console.log(res.data.business_discovery.media.data)
//           // 自分のアカウント
//           // console.log(res.data.media.data)
//         })
//         .catch(error => {
//           console.log("ERROR:: ", error.res.data);
//         });
//     },
//     computed: {
//       rePosts() {
//         return this.posts.slice(0, 4)
//       }
//     },
//   })
// }

// if (document.getElementById('insta__cocoplus')) {
//   const postsInstance = new Vue({
//     el: "#insta__cocoplus",
//     data() {
//       return {
//         insta_url: 'https://graph.facebook.com/v12.0/',
//         instagram_business_id: '17841450062107536',
//         access_token: 'EAAJKs8lGM8cBAMcr0FSCjTFtKuLiZBr8qMUZAMt1ZB8v73DhPjUKGGp9OSF564DOyvTyhXNG4u7r80qTw0DFphFMY7GlyBxmewWndVZBPVOwofxXRHSCUCyx0KNZBWsF8amPyOcmxO2nF6dzZCFvOoKSKF6lEJYaUIEGED7nMyJeEv5gZCxvL6SioId4FrXGWYZD',
//         target_user: 'cocoplus_1101',
//         // target_user: 'salon.coco.0731',
//         // query = 'business_discovery.username(' + target_user + '){id,followers_count,media_count,ig_id,media{caption,media_url,media_type,like_count,comments_count,timestamp,id}}',
//         // query: 'name,media{caption,like_count,media_url,permalink,timestamp,username}',
//         queryFirst: 'business_discovery.username(',
//         queryLast: '){followers_count,media_count,media{caption,like_count,media_url,media_type,permalink,timestamp,username}}',
//         // query: 'business_discovery.username(kaori.y_studio){followers_count,media_count,media{caption,like_count,media_url,permalink,timestamp,username}}',
//         posts: [],
//       }
//     },
//     mounted() {
//       console.log(this.insta_url + this.instagram_business_id + '?fields=' + this.queryFirst + this.target_user + this.queryLast + '&access_token=' + this.access_token)
//       axios(this.insta_url + this.instagram_business_id + '?fields=' + this.queryFirst + this.target_user + this.queryLast + '&access_token=' + this.access_token)
//         .then((res) => {
//           this.posts = res.data.business_discovery.media.data
//           // 他人のアカウント
//           // console.log(res.data.business_discovery.media.data)
//           // 自分のアカウント
//           // console.log(res.data.media.data)
//         })
//         .catch(error => {
//           console.log("ERROR:: ", error.res.data);
//         });
//     },
//     computed: {
//       rePosts() {
//         return this.posts.slice(0, 4)
//       }
//     },
//   })
// }


// /*******************
//   map
// *******************/
// // if (document.getElementById('Map')) {
// //   const mapInstance = new Vue({
// //     el: "#Map",
// //     data() {
// //       return {
// //         lat: 34.6704542,
// //         lng: 135.5013464,
// //         zoom: 16,
// //         icon: THEME_URL + "/assets/mappin.png",
// //         geometry: {
// //           hue: '#111',       // 色
// //           gamma: 0.1,        // ガンマ 0.01 ~ 10
// //           lightness: -70,    // 明度  -100 ~ 100
// //           saturation: -100,   // 彩度 -100 ~ 100
// //         },
// //         labels: {
// //           hue: '#ae9e74',       // 色
// //           gamma: 1,        // ガンマ
// //           lightness: 0,    // 明度
// //           saturation: -50, // 彩度
// //         }
// //       }
// //     },
// //     mounted() {
// //       let map
// //       let marker
// //       let center = {
// //         lat: Number(this.lat), // 緯度
// //         lng: Number(this.lng) // 経度
// //       }
// //       map = new google.maps.Map(document.getElementById('Map'), { // #sampleに地図を埋め込む
// //         center: center, // 地図の中心を指定
// //         zoom: this.zoom, // 地図のズームを指定
// //         disableDefaultUI: true,
// //         styles: [
// //           {
// //             featureType: 'all',
// //             elementType: 'geometry',
// //             stylers: [
// //               { hue: this.geometry.hue },
// //               { gamma: this.geometry.gamma },
// //               { lightness: this.geometry.lightness },
// //               { saturation: this.geometry.saturation },
// //             ],
// //           },
// //           {
// //             featureType: 'all',
// //             elementType: 'labels',
// //             stylers: [
// //               { hue: this.labels.hue },
// //               { gamma: this.labels.gamma },
// //               { lightness: this.labels.lightness },
// //               { saturation: this.labels.saturation },
// //             ],
// //           },
// //         ]
// //       })
// //       marker = new google.maps.Marker({ // マーカーの追加
// //         position: center, // マーカーを立てる位置を指定
// //         map: map, // マーカーを立てる地図を指定
// //         icon: this.icon // マーカーのアイコン指定
// //       })
// //     },
// //   })
// // }


// /*******************
//   posts
// *******************/

// // if (document.getElementById('Posts')) {
// //   const postsInstance = new Vue({
// //     el: "#Posts",
// //     data() {
// //       return {
// //         cats: [],
// //         posts: [],
// //         eventObject: '',
// //       }
// //     },
// //     mounted() {
// //       axios(BASEURL + 'posts')
// //         .then((res) => {
// //           this.posts = res.data
// //         })
// //       axios(BASEURL + 'categories')
// //         .then((res) => {
// //           this.cats = res.data.filter(item => item.slug != 'uncategorized')
// //         })
// //     },
// //     methods: {
// //       btnClicked(e) {
// //         axios(BASEURL + 'posts')
// //           .then((res) => {
// //             this.posts = res.data.filter(item => item.categories.includes(e))
// //           })
// //       }
// //     },
// //   })
// // }

// /*******************
//   posts
// *******************/

// // if (document.getElementById('Cat')) {
// //   const postsInstance = new Vue({
// //     el: "#Cat",
// //     data() {
// //       return {
// //         cats: [],
// //       }
// //     },
// //     mounted(){
// //       axios(BASEURL+'categories')
// //       .then( (res) =>{
// //         this.cats = res.data.filter(item => item.slug != 'uncategorized')
// //       })
// //     },
// //   })
// // }

// /*******************
//   tab機能1
// *******************/
// if (document.getElementById('tab')) {
//   //-- タブ切り替え --------------------------------------------------------------------
//   // 対象クラスのついているDOM全てを取得
//   var btn = document.getElementsByClassName('tab__btn');

//   // btn.length で 対象ボタンの個数全部を取得し、条件式が0になるまで回す。
//   // 要素indexは0から割り振られているので-1することで、個数を、indexに合わせる。
//   for (var i = btn.length - 1; i >= 0; i--) {
//     // 各ボタン、イベントリスナーでクリックしたら発動
//     btn[i].addEventListener('click', function () {

//       // btn.length で 対象ボタンの個数全部を取得し、条件式が0になるまで回す。
//       for (var x = btn.length - 1; x >= 0; x--) {
//         // contains で対象クラス有無をチェックし、あれば削除
//         if (btn[x].classList.contains('active')) {
//           btn[x].classList.remove('active');
//         }
//       }

//       // this はクリックされたオブジェクト。parentNode でその親。
//       // classList でクラス操作。active クラスの追加と削除。
//       this.classList.add('active');

//       // 対象クラスのついているDOM全てを取得
//       var box = document.getElementsByClassName('tab__container');
//       for (var y = box.length - 1; y >= 0; y--) {
//         // contains で対象クラス有無をチェックし、あれば削除
//         if (box[y].classList.contains('open')) {
//           box[y].classList.remove('open');
//         }
//       }

//       //data属性の値を取得して、同じidの要素にクラス付加。
//       var tab_id = this.getAttribute('data-tab');
//       document.getElementById(tab_id).classList.add('open');
//     });
//   }
// }


// /*******************
//   tab機能2
// *******************/
// window.addEventListener("load", function () {
//   // store tabs variable
//   var myTabs = document.querySelectorAll(".nav-tabs");
//   function myTabClicks(tabClickEvent) {
//     for (var i = 0; i < myTabs.length; i++) {
//       myTabs[i].classList.remove("active");
//     }
//     var clickedTab = tabClickEvent.currentTarget;
//     clickedTab.classList.add("active");
//     tabClickEvent.preventDefault();
//     var myContentPanes = document.querySelectorAll(".tab-content");
//     for (i = 0; i < myContentPanes.length; i++) {
//       myContentPanes[i].classList.remove("active");
//     }
//     var anchorReference = tabClickEvent.target;
//     var activePaneId = anchorReference.getAttribute("href");
//     var activePane = document.querySelector(activePaneId);
//     activePane.classList.add("active");
//   }

//   for (i = 0; i < myTabs.length; i++) {
//     myTabs[i].addEventListener("click", myTabClicks)
//   }
// });


// /*******************
//   見積もり機能
// *******************/
// if (document.getElementById('estimate')) {
//   const form = document.querySelectorAll('input[name=合計金額]')
//   const setu01 = document.querySelectorAll('input[name=メニュー01]')
//   const setu02 = document.querySelectorAll('input[name=オプション01]');
//   const radio = document.querySelectorAll("input[type='radio']")
//   console.log(radio)
//   for (i = 0; i < setu01.length; i++) {
//     setu01[i].addEventListener('click', function (e) {
//       price_sum();
//     });
//   }
//   //optionのクリックを監視
//   for (i = 0; i < setu02.length; i++) {
//     setu02[i].addEventListener('click', function (e) {
//       price_sum();
//     });
//   }
//   //合計計算
//   function price_sum() {
//     var sum = 0;
//     for (var i = 0; i < setu01.length; i++) {
//       if (setu01[i].checked) {
//         sum += parseInt(setu01[i].value);
//       }
//     }
//     for (var i = 0; i < setu02.length; i++) {
//       if (setu02[i].checked) {
//         sum += parseInt(setu02[i].value);
//       }
//     }
//     // console.log(form[0].value)
//     form[0].value = sum;
//   }
//   // for (let i = 0; i < setu01.length; i++) {
//   //   element.addEventListener('change',function(){})
//   //   const e = setu01[i];
//   //   e =
//   // }
// }

// /*******************
//   泡
// *******************/
// document.addEventListener('DOMContentLoaded', () => {
//   // コンテナを指定
//   const section = document.querySelector('.bubble-background');

//   // 泡を生成する関数
//   const createBubble = () => {
//     const bubbleEl = document.createElement('span');
//     bubbleEl.className = 'bubble';
//     const minSize = 10;
//     const maxSize = 50;
//     const size = Math.random() * (maxSize + 1 - minSize) + minSize;
//     bubbleEl.style.width = `${size}px`;
//     bubbleEl.style.height = `${size}px`;
//     bubbleEl.style.left = Math.random() * innerWidth + 'px';
//     section.appendChild(bubbleEl);

//     // 一定時間が経てば泡を消す
//     setTimeout(() => {
//       bubbleEl.remove();
//     }, 8000);
//   }

//   // 泡の生成を開始するトリガー（初期値はOFF）
//   let activeBubble = null;

//   // 泡の生成をストップする関数
//   const stopBubble = () => {
//     clearInterval(activeBubble);
//   };

//   // Intersection observerに渡すコールバック関数
//   const cb = (entries) => {
//     entries.forEach(entry => {
//       if (entry.isIntersecting) {
//         activeBubble = setInterval(createBubble, 300);
//       } else {
//         stopBubble();
//       }
//     })
//   };

//   // Intersection observerに渡すオプション
//   const options = {
//     rootMargin: "100px 0px"
//   }

//   // Intersection observerの初期化
//   const io = new IntersectionObserver(cb, options);
//   io.POLL_INTERVAL = 100; // Polyfill
//   io.observe(section);
// });

// import "../scss/bootstrap5.custom.scss";
// import "../scss/style.scss";
